import {Migration} from '@mydocma/core/src/lib/migration';
import {IDBPDatabase} from 'idb';
import { MmDbCollections } from '../../mm-db-schema';


export const V1: Migration = {

  up(database: IDBPDatabase<unknown>) {
    database.createObjectStore(MmDbCollections.personalization);
  },

};
